export const initialTelemetryState = {
  byId: {},
};

export function telemetryReducer(state, action) {
  switch (action.type) {
    case "telemetry/update": {
      const { deviceId, payload } = action;
      return {
        ...state,
        byId: {
          ...state.byId,
          [deviceId]: {
            ...(state.byId[deviceId] || {}),
            ...payload,
          },
        },
      };
    }
    default:
      return state;
  }
}

export function createTelemetryActions(dispatch) {
  return {
    updateTelemetry: (deviceId, payload) =>
      dispatch({ type: "telemetry/update", deviceId, payload }),
  };
}
